import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const PlanShortCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid ${colors.grey444};
  border-radius: 16px;
  padding: 24px;
  gap: 20px;
  height: 146px;
  min-width: 258.5px;
  margin-right: 16px;

  &.free-trial {
    background-color: ${colors.freeTrialYellow};
    border: 1px solid transparent;
  }
  &.starter-plan {
    background: ${colors.primaryLight};
    color: ${colors.mainDark};
  }
  &.pro-plan {
    background: ${colors.primary};
    color: ${colors.white};
  }
  &.ultra-plan {
    background: ${colors.ultraPlanDarkGreen};
    color: ${colors.white};
  }
  &.custom-plan {
    background: ${colors.templatesPurple};
    color: ${colors.purpleLight2};

    .min-users-amount {
      color: ${colors.grey1};
    }
  }
  &.clickable {
    cursor: pointer;
  }
  /* &.clickable:not(.selected) {
    cursor: default;
    &:hover {
      border-color: ${colors.primaryDark};
      background-color: ${colors.primaryLight};
    }
  } */
  &.white-background {
    background-color: ${colors.white};
    border-color: ${colors.grey444};
    color: ${colors.mainDark};
  }

  /* &.selected:not(.free-trial) {
    border-color: ${colors.primaryDark};
    background-color: ${colors.primary};
    color: ${colors.white} !important;
  } */

  .plan-pricing {
    display: flex;
    gap: 20px;
  }

  .plan-billing {
    display: flex;
    flex-direction: column;
    p {
      font-size: 14px;
    }
  }
  .badge {
    font-size: 12px;
    font-weight: 500;
    padding: 4px 8px;
    border-radius: 4px;
    margin-left: 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    width: fit-content;
    height: 20px;
    min-height: 20px;
  }

  .highlight {
    color: ${colors.intenseBlue} !important;
    background-color: ${colors.intenseBlueChipBackground} !important;
  }

  .more-than-5-users {
    color: ${colors.primaryDark};
    background: ${colors.primaryLight};
  }
  .min-users-amount {
    height: 24px;
    min-height: 24px;
    margin-top: -16px;
    margin-bottom: -12px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    color: ${colors.white};
  }
`;
